@import "../../../../scss/use-bootstrap-mixins.scss";

.simplifiedCheckout {
    display: grid;
    grid-template-columns: 1fr;
    gap: 24px;

    @include media-breakpoint-up(lg) {
        grid-template-columns: 1fr 1fr;
    }
}

// ─── Summary column (left on desktop) ───

.summaryColumn {
    order: 2;

    @include media-breakpoint-up(lg) {
        order: 1;
    }
}

.summaryCard {
    display: flex;
    flex-direction: column;
    gap: 40px;
    padding: 20px;
}

.unitInfoSection {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.unitHeader {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.summaryTitle {
    font-size: 20px;
    font-weight: 700;
    color: #000;
}

.unitNameGroup {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.unitName {
    font-size: 17px;
    color: #000;
}

.unitAddress {
    font-size: 12px;
    font-weight: 500;
    color: #7f7f7f;
}

.unitImageRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}

.unitImage {
    width: 96px;
    height: 96px;
    object-fit: cover;
    flex-shrink: 0;
    margin-right: 16px;
}

.priceBlock {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 10px;
    font-size: 12px;
}

.priceCurrent {
    color: #000;
}

.priceSavings {
    display: flex;
    align-items: center;
    gap: 5px;
}

.priceSave {
    color: #008106;
}

.priceWas {
    color: #878787;
}

.pricingSection {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.receiptHeading {
    font-size: 17px;
    font-weight: 700;
    color: #000;
}

.pricingDivider {
    border-top: 1px solid #e0e0e0;
    width: 100%;
}

.pricingRow {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    font-size: 12px;
    color: #000;
}

.pricingTotal {
    font-size: 15px;
    font-weight: 700;
}

.chargePeriod {
    display: inline-block;
    margin-left: 0.4em;
    font-size: 10px;
    color: #7f7f7f;
    white-space: nowrap;
}

.pricingSkeletonContainer {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

// ─── Form column (right on desktop) ───

.formColumn {
    order: 1;

    @include media-breakpoint-up(lg) {
        order: 2;
    }
}

.formSection {
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 4px 7.5px 0 rgba(0, 0, 0, 0.07);
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.formTitle {
    font-size: 20px;
    font-weight: 700;
    color: #000;
    margin: 0;
}

.nameRow {
    display: flex;
    flex-direction: column;
    gap: 15px;

    @include media-breakpoint-up(lg) {
        flex-direction: row;
        gap: 30px;
    }
}

.nameField {
    flex: 1;
}

.field {
    display: flex;
    flex-direction: column;
    gap: 10px;

    label {
        font-size: 12px;
        font-weight: 500;
        color: #808080;
    }

    input,
    select {
        padding: 10px;
        border: 0.79px solid #b7b7b7;
        border-radius: 5px;
        font-size: 12px;
        color: #000;
        outline: none;
        transition: border-color 0.2s;
        width: 100%;
        box-sizing: border-box;

        &::placeholder {
            color: #9b9b9b;
        }

        &:focus {
            border-color: var(--rs-theme);
        }
    }

    select {
        appearance: auto;
        background: #f4f4f4;
    }
}

.cardFieldsRow {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
}

.termsSection {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-top: 15px;
}

.termsLink {
    font-size: 12px;
    color: var(--rs-theme);
    text-decoration: underline;
    align-self: flex-start;

    &:hover {
        text-decoration: none;
    }
}

.submitSection {
    margin-top: 15px;

    button {
        width: 100%;
    }
}

.errorList {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.fieldError {
    display: block;
    font-size: 12px;
    color: red !important;
    font-style: italic;
    margin-top: 2px;
}

.cardNumberWrapper {
    display: flex;
    align-items: center;
    gap: 8px;

    input {
        flex: 1;
        min-width: 0;
    }

    .cardBrandIcon {
        display: flex;
        flex-shrink: 0;
        width: 48px;
        height: 32px;

        svg {
            width: 100%;
            height: 100%;
        }
    }
}

.datepicker {
    width: 100%;
    box-sizing: border-box;
}
